module.exports = __webpack_public_path__ + "static/media/furvac360-logo.01495b27.jpg";